// ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÐºÐ¾Ð½ÐºÑÐµÑÐ½Ð¾Ð³Ð¾ Ð±ÑÐ¾ÐºÐµÑÐ° Ð¿Ð¾Ð²ÐµÑÑ Ð±ÑÐµÐ½Ð´Ð°.
//
// ÐÑÐµÐ½Ð´ (REACT_APP_BRAND) â ÑÑÐ¾ Ð¿Ð°Ð»Ð¸ÑÑÐ° Ð¸ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿, Ð¸ Horizon Ð¾Ð±ÑÐ¸Ð¹ Ñ Rox Ð¸ JetQ.
// Ð Ð²Ð¾Ñ ÑÑÐ¾ Ð±ÑÐ¾ÐºÐµÑ Ð¿ÑÐ¾Ð´Ð°ÑÑ Ð¸ ÐºÐ°Ðº Ð½Ð°Ð·ÑÐ²Ð°ÐµÑÑÑ â Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÑÐ²Ð¾Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð°Ñ
// Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½Ð°Ñ ÑÐ±Ð¾ÑÐºÐ¸:
//
//   REACT_APP_TENANT=        â ÐºÐ°Ðº Ð±ÑÐ»Ð¾ (DOSCAR, Rox)
//   REACT_APP_TENANT=jetq    â JetQ: ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ,
//                              ÑÐ²Ð¾Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð±ÑÐ°ÑÐ·ÐµÑÐ°
import { CAR_ORIGIN_TYPES } from '../constants/carOrigin';

export const TENANTS = {
  jetq: {
    title: 'JetQ',
    // public/assets â Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸; Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ Ð¾ÑÑÐ°ÑÑÑÑ apple-touch-icon.png.
    favicon: '/assets/jetq-icon.png',
    // JetQ Ð½Ðµ Ð¿ÑÐ¾Ð´Ð°ÑÑ Ð½Ð¾Ð²ÑÐµ Ð°Ð²ÑÐ¾: ÑÐ°Ð·Ð´ÐµÐ»Ñ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» Ð² Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÑÂ» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð°ÑÂ» Ð½Ðµ Ð½ÑÐ¶Ð½Ñ.
    usedCarsOnly: true,
    // ÐÐ°ÑÐ¸Ð½Ñ JetQ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ.
    carOrigins: [CAR_ORIGIN_TYPES.CONSIGNMENT],
    // Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ (ÐÐ³ÐµÐ½Ñ â ÐÑÐ¾Ð´Ð°Ð²ÐµÑ â ÐÐ¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ) Ð¿Ð¾ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR.
    // Ð£ JetQ Ð²ÑÐµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â Ð±ÐµÐ· Ð²ÑÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ ÑÐ°Ð³ Ð²ÑÑÐ°Ð» Ð±Ñ Ð² ÐºÐ°Ð¶Ð´ÑÑ ÑÐ´ÐµÐ»ÐºÑ.
    tripartiteContract: false,
  },
};

export const resolveTenant = (value) => {
  const key = String(value || '').trim().toLowerCase();
  return TENANTS[key] || null;
};

export const tenant = resolveTenant(process.env.REACT_APP_TENANT);

// Ð Ð°Ð·Ð´ÐµÐ»Ñ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» Ð² Ð¼ÐµÐ½Ñ Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð¸Â».
const NEW_CARS_PATHS = ['/cars/new', '/deals/new'];

/** ÐÑÐ½ÐºÑÑ Ð¼ÐµÐ½Ñ Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð¸Â»: Ñ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÐÐ£-Ð°Ð²ÑÐ¾ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» ÑÐ±Ð¸ÑÐ°ÐµÐ¼. */
export const usedOnlyMenuChildren = (children, current = tenant) =>
  current?.usedCarsOnly ? children.filter((item) => !NEW_CARS_PATHS.includes(item.path)) : children;

/** ÐÐ°ÑÐ¸Ð°Ð½ÑÑ Â«ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÂ»: Ñ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ â ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð½Ð¸. */
export const allowedOriginOptions = (options, current = tenant) =>
  current?.carOrigins ? options.filter((option) => current.carOrigins.includes(option.value)) : options;

/** ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð±ÑÐ°ÑÐ·ÐµÑÐ°. */
export const applyTenant = (doc = document, current = tenant) => {
  if (!current) return;
  if (current.title) doc.title = current.title;
  if (current.favicon) {
    doc.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((link) => {
      link.setAttribute('href', current.favicon);
    });
  }
};

/** ÐÑÐ¶ÐµÐ½ Ð»Ð¸ ÑÐ°Ð³ Â«Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÂ» Ð² ÑÐ´ÐµÐ»ÐºÐ°Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ. */
export const tripartiteContractEnabled = (current = tenant) => current?.tripartiteContract !== false;
